module.exports = __webpack_public_path__ + "img/exit-icon.a21154b3.svg";